import NBType, { InferType } from '@netbase/nb-type'
import DetectType from '../enums/DetectType'
import LogoTypeSchema from './LogoTypeSchema'

/**
 * @typedef {import('../enums/DetectType').DetectType} DetectType
 * @typedef {import('./LogoTypeSchema').LogoType} LogoType
 */

/**
 * @typedef {object} RecognizedMediaSchema
 * @property {LogoType[]} logoTypes
 * @property {string} mediaUrl
 * @property {string[]} names
 * @property {DetectType} type
 */
const RecognizedMediaSchema = NBType.object().shape('RecognizedMediaSchema', {
  /* @prop */
  logoTypes: NBType.array().of(LogoTypeSchema).nullable(),
  /* @prop */
  mediaUrl: NBType.string().nullable(),
  /* @prop */
  names: NBType.array().of(NBType.string()),
  /* @prop */
  type: NBType.enum(DetectType)
  /* END */
})
export default RecognizedMediaSchema
export type RecognizedMedia = InferType<typeof RecognizedMediaSchema>
// RESERVE BELOW
